/**
 * Log levels
 */
export enum Level {
  ERROR,
  WARN,
  INFO,
  DEBUG,
  LOG
}